"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateEffect = exports.useScaledRightLimit = exports.useScaledBottomLimit = exports.usePrevious = exports.useOutsideClick = exports.useLatest = exports.useInfiniteScrollWithRefCallback = exports.useInfiniteScroll = void 0;

var _react = require("react");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var useOutsideClick = function useOutsideClick(ref, handler) {
  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handler(event);
      }
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

exports.useOutsideClick = useOutsideClick;

var useInfiniteScroll = function useInfiniteScroll(element, callback, disabled) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFetching = _useState2[0],
      setIsFetching = _useState2[1];

  (0, _react.useEffect)(function () {
    function isScrolling(e) {
      if (e.currentTarget.scrollTop === 0 || e.currentTarget.scrollHeight - e.currentTarget.scrollTop !== e.currentTarget.clientHeight || isFetching) return;
      setIsFetching(true);
    }

    if (element && !disabled) {
      element.addEventListener('scroll', isScrolling);
      return function () {
        return element.removeEventListener('scroll', isScrolling);
      };
    }
  }, [element, isFetching, disabled]);
  (0, _react.useEffect)(function () {
    if (!isFetching || disabled) return;
    callback();
  }, [isFetching]);
  return [isFetching, setIsFetching];
};

exports.useInfiniteScroll = useInfiniteScroll;

var useInfiniteScrollWithRefCallback = function useInfiniteScrollWithRefCallback(callback, disabled) {
  var distanceInPixels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFetching = _useState4[0],
      setIsFetching = _useState4[1];

  var scrolledToBottom = function scrolledToBottom() {
    if (!disabled && !isFetching) setIsFetching(true);
  };

  var scrolledRef = (0, _react.useRef)(scrolledToBottom);
  (0, _react.useEffect)(function () {
    scrolledRef.current = scrolledToBottom;
  });
  var ref = (0, _react.useRef)(null);
  var setRef = (0, _react.useCallback)(function (node) {
    function isScrolling(e) {
      if (e.currentTarget.scrollTop === 0 || Math.round(e.currentTarget.scrollHeight - e.currentTarget.scrollTop) > e.currentTarget.clientHeight + distanceInPixels) return;
      scrolledRef.current();
    }

    if (ref.current) {
      ref.current.removeEventListener('scroll', isScrolling);
    }

    if (node) {
      node.addEventListener('scroll', isScrolling);
    }

    ref.current = node;
  }, []);
  (0, _react.useEffect)(function () {
    if (!isFetching || disabled) return;
    callback();
  }, [isFetching, disabled]);
  return [setRef, isFetching, setIsFetching];
};

exports.useInfiniteScrollWithRefCallback = useInfiniteScrollWithRefCallback;

var useScaledRightLimit = function useScaledRightLimit() {
  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      limit = _useState6[0],
      setLimit = _useState6[1];

  var elementRef = (0, _react.useCallback)(function (node) {
    if (node !== null) {
      var rect = node.getBoundingClientRect();

      if (rect.left + rect.width / 0.8 > window.innerWidth) {
        console.log('trespass');
        setLimit(true);
      }
    }
  }, []);
  return [elementRef, limit];
};

exports.useScaledRightLimit = useScaledRightLimit;

var useScaledBottomLimit = function useScaledBottomLimit() {
  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      limit = _useState8[0],
      setLimit = _useState8[1];

  var elementRef = (0, _react.useCallback)(function (node) {
    if (node !== null) {
      // const rect = node.getBoundingClientRect();
      var parent = getScrollParent(node);
      var top = node.offsetTop + node.parentNode.offsetTop - parent.offsetTop;
      console.log('meassurements: ', node.offsetTop, node.parentNode.offsetTop, parent.offsetTop, '=>', top, node.scrollHeight, '=>', top + node.scrollHeight, '?', parent.clientHeight);

      if (top + node.scrollHeight > parent.clientHeight) {
        console.log('trespass');
        setLimit(true);
      }
    }
  }, []);
  return [elementRef, limit];
};

exports.useScaledBottomLimit = useScaledBottomLimit;

var getScrollParent = function getScrollParent(node) {
  var regex = /(auto|scroll)/;

  var parents = function parents(_node, ps) {
    if (_node.parentNode === null) {
      return ps;
    }

    return parents(_node.parentNode, ps.concat([_node]));
  };

  var style = function style(_node, prop) {
    return getComputedStyle(_node, null).getPropertyValue(prop);
  };

  var overflow = function overflow(_node) {
    return style(_node, 'overflow') + style(_node, 'overflow-y') + style(_node, 'overflow-x');
  };

  var scroll = function scroll(_node) {
    return regex.test(overflow(_node));
  };
  /* eslint-disable consistent-return */


  var scrollParent = function scrollParent(_node) {
    if (!(_node instanceof HTMLElement || _node instanceof SVGElement)) {
      return;
    }

    var ps = parents(_node.parentNode, []);

    for (var i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent(node);
  /* eslint-enable consistent-return */
};

var useLatest = function useLatest(value) {
  var valueRef = (0, _react.useRef)(value);
  (0, _react.useEffect)(function () {
    valueRef.current = value;
  });
  return valueRef;
};

exports.useLatest = useLatest;

var usePrevious = function usePrevious(value) {
  var valueRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    valueRef.current = value;
  }, [value]);
  return valueRef.current;
};

exports.usePrevious = usePrevious;

var useUpdateEffect = function useUpdateEffect(fn, inputs) {
  var didMountRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (didMountRef.current) return fn();else didMountRef.current = true;
  }, inputs);
};

exports.useUpdateEffect = useUpdateEffect;